import Axios from '@/assets/js/AxiosPlugin'

// 核销记录列表
export const verifyList = params => { return Axios.post('/api/Admin/Points/verifyList', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/CreditMall/VerifyListApp/apis/index.js